module.exports = __webpack_public_path__ + "step2.cb13381.png";